import { render, staticRenderFns } from "./SeriesVideoitem.vue?vue&type=template&id=523c151e&"
import script from "./SeriesVideoitem.vue?vue&type=script&lang=js&"
export * from "./SeriesVideoitem.vue?vue&type=script&lang=js&"
import style0 from "./SeriesVideoitem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SeriesVideoitem.vue"
export default component.exports